import React from 'react';
import { TileContainer, TileIcon, TileTitle } from './styled';

export interface SugesstionsTileProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  children?: React.ReactNode;
}

const AIBadgeIcon: React.FC = () => (
  //TO be replaced with actual icons
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="14"
    height="14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    aria-hidden="true"
    focusable="false"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.847a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.847.813a4.5 4.5 0 0 0-3.09 3.09Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.456-2.456L14.25 6l1.035-.259a3.375 3.375 0 0 0 2.456-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.894 19.644 16.5 21l-.394-1.356a2.25 2.25 0 0 0-1.55-1.55L13.2 17.7l1.356-.394a2.25 2.25 0 0 0 1.55-1.55L16.5 14.4l.394 1.356a2.25 2.25 0 0 0 1.55 1.55l1.356.394-1.356.394a2.25 2.25 0 0 0-1.55 1.55Z"
    />
  </svg>
);

const SugesstionsTile: React.FC<SugesstionsTileProps> = ({ title, icon, onClick }) => {
  return (
    <TileContainer onClick={onClick} role="button" tabIndex={0}>
      <TileIcon>{icon ?? <AIBadgeIcon />}</TileIcon>
      <TileTitle>{title}</TileTitle>
    </TileContainer>
  );
};

export default SugesstionsTile;
